import React, { useState } from "react";
import { Heart, Send } from "lucide-react";

const SelectionSubmitForm = ({ selectedCount = 0, onSubmit, loading = false }) => {
  const [form, setForm] = useState({
    client_name: "",
    client_email: "",
    client_phone: "",
    notes: "",
  });
  const [expanded, setExpanded] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.client_name || !form.client_email) return;
    onSubmit(form);
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-lg z-40">
      <div className="max-w-4xl mx-auto px-4 py-3">
        {!expanded ? (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm">
              <Heart className="w-4 h-4 text-pink-500 fill-pink-500" />
              <span className="font-medium">{selectedCount} zdjec wybranych</span>
            </div>
            <button
              onClick={() => setExpanded(true)}
              className="bg-pink-500 hover:bg-pink-600 text-white px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors"
            >
              <Send className="w-4 h-4" /> Wyslij wybor
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="flex items-center justify-between mb-1">
              <span className="font-medium text-sm flex items-center gap-2">
                <Heart className="w-4 h-4 text-pink-500 fill-pink-500" />
                {selectedCount} zdjec wybranych
              </span>
              <button type="button" onClick={() => setExpanded(false)} className="text-sm text-slate-500 hover:text-slate-700">
                Zwiń
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <input
                type="text"
                placeholder="Imie i nazwisko *"
                value={form.client_name}
                onChange={set("client_name")}
                required
                className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-pink-500 focus:outline-none"
              />
              <input
                type="email"
                placeholder="Email *"
                value={form.client_email}
                onChange={set("client_email")}
                required
                className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-pink-500 focus:outline-none"
              />
              <input
                type="tel"
                placeholder="Telefon (opcjonalnie)"
                value={form.client_phone}
                onChange={set("client_phone")}
                className="border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-pink-500 focus:outline-none"
              />
            </div>
            <textarea
              placeholder="Notatka dla fotografa (opcjonalnie)"
              value={form.notes}
              onChange={set("notes")}
              rows={2}
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-pink-500 focus:outline-none resize-none"
            />
            <button
              type="submit"
              disabled={loading || !form.client_name || !form.client_email}
              className="bg-pink-500 hover:bg-pink-600 text-white px-6 py-2.5 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors disabled:opacity-50"
            >
              <Send className="w-4 h-4" />
              {loading ? "Wysylanie..." : `Wyslij wybor (${selectedCount} zdjec)`}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default SelectionSubmitForm;
